<template>
  <div class="my-1" v-if="order">
    <div class="row m-1">
      <div class="col-md-10">
        <div class="flex">
          <h2>
            <span class="badge" :class="chooseBadgeColor">
              {{ chooseStatusName }}
            </span>
          </h2>
        </div>
      </div>
      <div class="col-12 col-md-2 row">
        <button class="btn btn-info btn-active" @click="downloadCommandPdf(order.order_id)">
          Imprimir
        </button>
      </div>
    </div>

    <div class="row m-1">
      <div class="col-6 mt-3">
        <div class="flex">
          <strong>ID:</strong>
          {{ order.id }}
        </div>
        <div class="flex">
          <strong>Tipo de entrega:</strong>
          {{ getTypeDelivery(order) }}
        </div>
        <div class="flex">
          <strong>Cliente:</strong>
          {{ order.customer }}
        </div>
        <div class="flex">
          <strong>Tipo cliente:</strong>
          {{ order.typeUser }}
        </div>
        <div class="flex">
          <strong>Cocina:</strong>
          {{ order.dark_kitchen }}
        </div>
        <div class="flex">
          <strong>Telefono:</strong>
          {{ order.phone }}
        </div>
        <div class="flex">
          <strong>Fecha:</strong>
          {{ order.created_at }}
        </div>
        <div class="flex">
          <strong>Marca:</strong>
          {{ order.brand }}
        </div>
        <div class="flex">
          <strong>Hora pedido programado:</strong>
          {{ order.delivery_time_formatted }}
        </div>
        <div class="flex mt-2" v-if="order.source_in_app">
          <strong class="mr-2">Origen de pedido:</strong>
          <span class="badge badge-pill text-uppercase" :class="getSourceClass(order.source_in_app)" :style="getSourceStyle(order.source_in_app)">
            {{ getSourceLabel(order.source_in_app) }}
          </span>
        </div>
      </div>
      <div class="col-6">
        <div class="" v-if="orderStatusBoard.PENDING.status.includes(order.status_tracking_id)">
          <div class="card-shadow">
            <div class="card-shadow-title text-center">
              Tiempo de preparación
            </div>
            <div class="card-shadow-subtitle text-center">
              Ingrese la duración de preparación en minutos:
            </div>
            <div class="mt-3">
              <el-select class="select-primary pagination-select block" :clearable="true"
                         v-model="selectedPreparationTime"
                         placeholder="0 min">
                <el-option class="select-primary" v-for="times in listPreparationTimes" :key="times.value"
                           :label="times.label"
                           :value="times">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="text-center mt-3">
            <button class="btn btn-preparation-order" @click="updateOrderStatus(order,orderStatusBoard.IN_PREPARATION.status)"
                    :class="selectedPreparationTime === '' ? 'disabled' : 'btn-active'">
              PEDIDO EN PREPARACIÓN
            </button>
            <button class="btn btn-cancel-order mt-2" @click="cancelOrder(order)" v-if="selectedPreparationTime === ''">
              Cancelar pedido
            </button>
          </div>
        </div>
        <div class=""
             v-if="[orderStatusBoard.READY.status,orderStatusBoard.IN_PREPARATION.status,orderStatusBoard.IN_ROUTE.status].includes(order.status_tracking_id)">
          <div class="card-shadow">
            <div class="card-shadow-title">
              Repartidor:
            </div>
            <div class="card-shadow-subtitle text-center">
              <div class="" v-if="pendingAssignmentDealer(dealer)">Pendiente por asignarse</div>
              <div class="text-left card-dealer-info" v-else>
                <div>{{ dealer.name }}</div>
                <div>Email: {{ dealer.email }}</div>
                <div>Tel: {{ dealer.phone }}</div>
              </div>
            </div>

          </div>
          <div class="text-center mt-3" v-if="[orderStatusBoard.IN_PREPARATION.status].includes(order.status_tracking_id)">
            <button class="btn btn-preparation-order btn-active" @click="updateOrderStatus(order,orderStatusBoard.READY.status)">
              PEDIDO LISTO
            </button>
          </div>
          <div class="text-center mt-3" v-if="[orderStatusBoard.READY.status].includes(order.status_tracking_id) && order.order_delivery_type === 'pickup'">
            <button class="btn btn-preparation-order btn-active" @click="updateOrderStatus(order, orderStatusBoard.DELIVERED.status)">
              ENTREGADO
            </button>
          </div>
        </div>

      </div>
    </div>

    <div class="card mt-4">
      <el-table :data="itemsTable.items" row-key="id" header-row-class-name="thead-light"
                v-if="itemsTable.items.length !== 0">
        <el-table-column v-for="column in itemsTable.columns" :key="column.label" v-bind="column">
          <template slot-scope="scope">
            <div v-if="column.prop === 'sections'">
              <div v-for="(items, category) in groupSections(scope.row.sections)" :key="category" class="section-group">
                <strong>{{ category }}:</strong>
                <div class="section-items">
                  <div v-for="item in items" :key="item" class="section-item">{{ item }}</div>
                </div>
              </div>
            </div>
            <span v-else>{{ scope.row[column.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="card p-3" v-if="orderDetails && order && [orderStatusBoard.READY.status,orderStatusBoard.IN_ROUTE.status].includes(order.status_tracking_id)">
      <div class="row">
        <div class="col-12">
          <div class="flex" v-if="orderDetails.order.order_type_label">
            <strong>Tipo de pedido:</strong>
            {{ orderDetails.order.order_type_label }}
          </div>
          <div class="flex">
            <strong>Dirección:</strong>
            {{ orderDetails.order.address }}
          </div>
          <div class="flex">
            <strong> Tipo de entrega:</strong>
            {{ orderDetails.order.option_delivery }}
          </div>
          <div class="flex">
            <strong>Instrucciones: </strong>
            {{ orderDetails.order.reference }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import BackofficeApi from "../../gateways/backoffice-api";
import CustomModal from "../../components/CustomModal";
import OrderStatusBoard from "../../utils/OrderStatusBoard";

import {
  Table,
  TableColumn,
  Select, Option,
} from "element-ui";
import swal from 'sweetalert2';
import {format} from "date-fns";
import backofficeApi from "@/gateways/backoffice-api";
import moment from "moment/moment";

export default {
  name: "starter-page",
  props: {
    order: {
      type: Object, // Specify the type of the prop
      required: false // If the prop is required or not
    }
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    CustomModal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      selectedPreparationTime: '',
      changeStatusModal: false,
      orderDetails: null,
      itemsTable: {
        items: [],
        columns: [
          {
            prop: 'meal',
            label: 'Producto',
            minWidth: 150,
            sortable: true,
          },
          {
            prop: 'quantity',
            label: 'Cant.',
            minWidth: 110,
            sortable: true,
          },
          {
            prop: 'note',
            label: 'Nota',
            minWidth: 200,
            sortable: true,
          },
          {
            prop: 'sections',
            label: 'Agre.',
            minWidth: 300,
            sortable: true,
          },
        ],
      },
      dealer: null,
      orderStatusBoard: OrderStatusBoard,
    };
  },
  computed: {
    host() {
      return process.env.VUE_APP_API_BACKOFFICE_URL.replace("/api/v1/", "");
    },
    listPreparationTimes() {
      const times = [];
      for (let i = 1; i <= 60; i += 1) {
        times.push({value: i, label: `${i} min`});
      }
      return times;
    },
    chooseStatusName() {
      const statusTrackingId = this.order ? this.order.status_tracking_id : 0;

      if (OrderStatusBoard.PENDING.status.includes(statusTrackingId)) {
        return OrderStatusBoard.PENDING.name;
      }

      if (OrderStatusBoard.IN_PREPARATION.status === statusTrackingId) {
        return OrderStatusBoard.IN_PREPARATION.name;
      }

      if (OrderStatusBoard.READY.status === statusTrackingId) {
        return OrderStatusBoard.READY.name;
      }

      if (OrderStatusBoard.IN_ROUTE.status === statusTrackingId) {
        return OrderStatusBoard.IN_ROUTE.name;
      }

      if (OrderStatusBoard.CANCELED.status === statusTrackingId ) {
        return OrderStatusBoard.CANCELED.name;
      }

      return 'UNKNOWN';

    },
    chooseBadgeColor() {
      const statusTrackingId = this.order ? this.order.status_tracking_id : 0;

      if (OrderStatusBoard.PENDING.status.includes(statusTrackingId)) {
        return 'card-badge-time card-badge-start-preparation-pending';
      }

      if (OrderStatusBoard.IN_PREPARATION.status === statusTrackingId) {
        return 'card-badge-time card-badge-start-preparation-in-preparation';
      }

      if (OrderStatusBoard.READY.status === statusTrackingId) {
        return 'card-badge-time card-badge-start-preparation-ready';
      }

      if (OrderStatusBoard.IN_ROUTE.status === statusTrackingId) {
        return 'card-badge-time card-badge-start-preparation-in-route';
      }

      return 'card-badge-time card-badge-start-preparation-pending';

    }
  },
  watch: {
    order: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) this.loadOrderDetails(newVal);
    }
  },
  methods: {
    groupSections(sections) {
      if (!sections || !Array.isArray(sections) || sections.length === 0) {
        return {};
      }

      const grouped = {};
      sections.forEach((section) => {
        const description = section.general_description || 'Other';
        const itemName = section.meal_section || 'Unknown';

        if (!grouped[description]) {
          grouped[description] = [];
        }
        grouped[description].push(itemName);
      });

      return grouped;
    },
    getTypeDelivery(order) {
      if(order.order_delivery_type === 'delivery') {
        return 'Domicilio';
      }else if(order.franchise_delivery_type === 'eat_here'){
        return 'Recojo - comer aqui'
      }
      return 'Recojo - llevar'
    },
    getSourceLabel(source) {
      const s = source.toLowerCase();
      if (s === 'restaurante') {
        return 'Restaurante';
      } else if (s === 'menu_diario') {
        return 'Menú Diario';
      }
      return source.replace('_', ' ');
    },
    getSourceClass(source) {
      const s = source.toLowerCase();
      if (s === 'restaurante') {
        return 'badge-info';
      } else if (s === 'menu_diario') {
        return 'badge-source-menu-diario';
      }
      return 'badge-source-menu-diario';
    },
    getSourceStyle(source) {
      const s = source.toLowerCase();
      if (s === 'menu_diario') {
        return 'background-color: #E1FEF1; color: #1AAE6F;';
      }
      return '';
    },
    async updateOrderStatus(order, statusTrackingId, eventAction = 'click') {
      if (statusTrackingId === OrderStatusBoard.IN_PREPARATION.status) {
        order.time_prep_entered = this.selectedPreparationTime.value;
        order.status_tracking_id = statusTrackingId;
        order.status_name = OrderStatusBoard.IN_PREPARATION.name;
        this.selectedPreparationTime = '';
      }

      if (statusTrackingId === OrderStatusBoard.READY.status) {
        order.status_tracking_id = statusTrackingId;
        order.status_name = OrderStatusBoard.READY.name;
        order.date_ready = format(new Date(), 'HH:mm:ss')
      }

      if (statusTrackingId === OrderStatusBoard.DELIVERED.status) {
        console.log(order)
        order.status_tracking_id = statusTrackingId;
        order.status_name = OrderStatusBoard.READY.name;
        order.date_ready = format(new Date(), 'HH:mm:ss')
      }

      // CALL API TO UPDATE ORDER STATUS
      await this.updateOrder(order, eventAction);

    },
    cancelOrder(order) {
      swal({
        title: '¿Cancelar pedido?',
        text: `¿Estás seguro de que deseas cancelar el pedido ID ${order.order_id}?`,
        type: 'warning',
        html: `¿Estás seguro de que deseas cancelar el pedido <b>ID ${order.order_id}</b>? <br><br>
            Ten en cuenta que se aplicará una penalidad del <b> 20%</b> del total del pedido sin delivery por la cancelación. `,
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Si, cancelar!',
        cancelButtonText: 'No',
        buttonsStyling: false
      }).then(async (result) => {
        if (result.value) {
          order.status_tracking_id = OrderStatusBoard.CANCELED.status;
          order.status_name = OrderStatusBoard.CANCELED.name;
          this.selectedPreparationTime = '';

          // CALL API TO CANCEL ORDER
          await this.updateOrder(order, 'click');

          swal({
            title: 'Pedido Cancelado!',
            text: `El pedido ha sido cancelado`,
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        }
      });
    },
    async updateOrder(order, eventAction) {
      try {
        this.$emit('onLoading', true);
        const path = `${this.host}/api/v3/foodcourt/orders/status`;
        const data = {
          id: order.order_id,
          status: order.status_tracking_id,
          dark_kitchen_id: order.dark_kitchen_id,
          enable_change_status_event: true,
          prep_time: order.time_prep_entered,
        }

        const response = await BackofficeApi.patch(path, data);

        if (order.status_tracking_id === OrderStatusBoard.IN_PREPARATION.status) {
          order.hour_estimated_ready = response.data.detail.hour_estimated_ready;
        }

        if (order.status_tracking_id === OrderStatusBoard.READY.status) {
          order.date_ready = response.data.detail.date_ready;
        }

        this.$emit('onLoading', false);
        this.$emit('onOrderChange', order, eventAction);
      } catch (e) {
        this.$emit('onLoading', false);
      }
    },
    async loadOrderDetails(order) {
      this.$emit('onLoading', true);
      const path = `${this.host}/api/v3/foodcourt/orders/show/${order.id}`;
      const orderDetails = await BackofficeApi.get(path);
      this.orderDetails = orderDetails.data.detail.order_details;
      this.itemsTable.items = orderDetails.data.detail.order_details.items;
      this.dealer = orderDetails.data.detail.order_details.dealer;
      this.$emit('onLoading', false);
    },
    pendingAssignmentDealer(value) {
      return value === null;
    },
    async downloadCommandPdf(id) {
      const path = `${this.host}/api/v3/foodcourt/orders/${id}/commands/download`;

      try {
        const response = await BackofficeApi.get(path, {
          responseType: "blob",  // Asegura que la respuesta sea un blob (archivo binario)
        });

        // Crear un URL a partir del blob
        const blob = new Blob([response.data], { type: "application/pdf" }); // Asegura que el tipo sea PDF
        const url = window.URL.createObjectURL(blob);

        // Crear y disparar la descarga del archivo PDF
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `comanda-${id}.pdf`);
        document.body.appendChild(link);
        link.click();

        // Abre el PDF en una nueva pestaña y lo envía a imprimir
        setTimeout(() => {
          const printWindow = window.open(url);
          printWindow.addEventListener("load", function() {
            printWindow.focus(); // Asegura que la nueva ventana esté enfocada
            printWindow.print(); // Envía a imprimir
          });
        }, 1000);

      } catch (error) {
        console.log(error);
        return Promise.reject(error);  // Maneja el error
      } finally {
        this.loadingDownload = false;  // Cambia el estado de carga
      }
    }
  },
};
</script>
<style lang="scss">
.weight {
  width: 30%;
  border: 1px solid black;

  td,
  th,
  tr {
    border: 1px solid black;
  }
}
</style>
<style>
.noMargin {
  margin-bottom: 0rem;
}

.starter-page {
  min-height: calc(100vh - 380px);
}

.recipe img {
  max-width: 100%;
}

p {
  white-space: pre-line
}

@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }

  #print,
  #print * {
    visibility: visible;
  }

  #print {
    position: absolute;
    left: 0;
    top: 0;
  }
}

@media all and (max-width: 480px) {
  .block-sm {
    width: 100%;
    display: block;
  }
}

.card-shadow {
  background-color: white;
  border-radius: 10px;
  padding: 16px 20px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.card-shadow .card-shadow-title {
  font-weight: 600;
  font-size: 16px;
  border-bottom: none;
  padding: 0;
  margin-bottom: 0;
}

.card-shadow-subtitle {
  font-size: 14px;
  color: rgba(144, 153, 147, 1);
  margin-top: 10px;
  font-weight: 400;
}

.btn-preparation-order {
  border-color: rgba(131, 146, 171, 1);
  color: rgba(131, 146, 171, 1);
}

.btn-preparation-order.disabled {
  cursor: not-allowed;
  pointer-events: none;
}

.btn-preparation-order.btn-active {
  background-image: linear-gradient(90deg, rgba(45, 206, 137, 1) 0%, rgba(45, 206, 204, 1) 100%);
  border: none;
  color: #FFFFFF;
}

.btn-preparation-order:hover {
  background-color: rgba(131, 146, 171, 1);
  color: white;
}

.btn-cancel-order {
  color: rgba(242, 17, 17, 1);
  border-radius: 5px;
}

.btn-cancel-order:hover {
  color: rgba(242, 17, 17, 1);
  box-shadow: none;
}

.card-dealer-info {
  color: rgba(50, 50, 93, 1);
  font-weight: 400;
  font-size: 14px;
}

.card-badge-time {
  border-radius: 8px;
  color: #FFFFFF;
}

.card-badge-start-preparation-pending {
  background-color: #E7F0FD;
  color: #1171EF;
  font-weight: 600;
  font-size: 14px;
}

.card-badge-start-preparation-in-preparation {
  background-color: #FFEDE9;
  color: #FB6340;
  font-weight: 600;
  font-size: 14px;
}

.card-badge-start-preparation-ready {
  background-color: #E1FEF1;
  color: #1AAE6F;
  font-weight: 600;
  font-size: 14px;
}

.card-badge-start-preparation-in-route {
  background-color: #E7E9FF;
  color: #596CFF;
  font-weight: 600;
  font-size: 14px;
}

#swal2-content {
  font-size: 16px;
  font-weight: 400;
}

.badge-source-menu-diario {
  background-color: #E1FEF1 !important;
  color: #1AAE6F !important;
}

.section-group {
  margin-bottom: 8px;
  padding: 6px;
  border-left: 3px solid #2DCE89;
  background: #f8f9fa;
  border-radius: 3px;
}

.section-group strong {
  color: #2DCE89;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  display: block;
  margin-bottom: 4px;
}

.section-items {
  color: #333333;
  font-size: 13px;
  line-height: 1.4;
}

.section-item {
  padding: 2px 0;
  margin-left: 8px;
}

</style>
